import React, { useEffect, useState, useCallback } from "react";

import Navbar from "../components/Navbar";
import Header from "./Header";
// import "./Header.css";
import "./MyBookings.css";

import moment from "moment";

import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const MyBookings = () => {
  const navigate = useNavigate();

  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";
  const [paginatedBookingList, setPaginatedBookingList] = useState([]);

  const [noData, setNoData] = useState();
  const [bookingData, setBookingData] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [statusCheck, setStatusCheck] = useState(false);
  const [isShow, invokeModal] = React.useState(false);
  const [editableRoom, setEditableRoom] = React.useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [showPopup, setShowPopup] = useState(false);
  // const [cancellationReason, setCancellationReason] = useState("");
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [selectedRI, setSelectedRI] = useState(""); // Stores selected RI value
  const [selectedBookingId, setSelectedBookingId] = useState(null); // Stores the booking ID
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [discountReason, setDiscountReason] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [cancelReason, setCancelReason] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  //  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const [calculatedDiscount, setCalculatedDiscount] = useState(0); // ✅ Fix: Define state variable
  const [refundPercentage, setRefundPercentage] = useState(0);
  const [calculatedRefund, setCalculatedRefund] = useState(0);
  const [refundReason, setRefundReason] = useState("");
  const [showRefundModal, setShowRefundModal] = useState(false);

  const handleProcessRefund = async () => {
    if (!selectedBooking) {
      console.error("Error: No booking selected.");
      return;
    }

    // Get user role from localStorage
    const userRole = localStorage.getItem("userRole");

    if (!userRole) {
      console.error("Error: User role not found in localStorage.");
      return;
    }

    // Ensure required fields are defined
    if (!refundReason || calculatedRefund === undefined) {
      console.error("Error: Missing refund reason or refund amount.");
      return;
    }

    // Calculate total refund amount
    const totalRefund =
      calculatedRefund + (selectedBooking.discount_amount || 0);

    // Prepare refund payload
    const refundData = {
      booking_group_id: selectedBooking.booking_group_id,
      added_by: userRole, // Fetch role instead of user ID
      refundReason,
      refundAmount: calculatedRefund,
      securityDeposit: selectedBooking.total_security_deposit || 0,
      discountAmount: selectedBooking.discount_amount || 0,
      totalRefund,
    };

    console.log("Processing Refund:", refundData);

    try {
      // Send refund request to backend
      const response = await fetch(`${host}/process-refund`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(refundData),
      });

      const result = await response.json();

      if (response.ok) {
        console.log("Refund successful:", result);

        console.log("Closing modal..."); // Debug log

        setShowDiscountModal(false);
      } else {
        console.error("Refund failed:", result.message);
      }
    } catch (error) {
      console.error("Error processing refund:", error);
    }
  };

  const [rooms, setRooms] = useState([
    { id: 1, ri_value: "" }, // Example initial state
    { id: 2, ri_value: "" },
  ]);

  const handleChange = (event, id) => {
    const newValue = event.target.value;

    setRooms((prevRooms) =>
      prevRooms.map((room) =>
        room.id === id ? { ...room, ri_value: newValue } : room
      )
    );
  };

  // Function to calculate discount amount dynamically
  const handleDiscountChange = (e) => {
    const percentage = parseFloat(e.target.value);
    setDiscountPercentage(percentage);

    if (!isNaN(percentage) && percentage >= 0 && percentage <= 100) {
      const rentPlusGst =
        (selectedBooking.total_rent || 0) + (selectedBooking.total_gst || 0);
      const discountAmount = (rentPlusGst * percentage) / 100;
      setCalculatedDiscount(discountAmount);
    } else {
      setCalculatedDiscount(0);
    }
  };

  const handleCancelClick = (item) => {
    setSelectedItem(item); // Set the selected booking
    setShowCancelModal(true); // Show the modal
  };

 

  const openModal = (booking) => {
    setSelectedBooking({
      ...booking,
      ri_value: selectedRI[booking.booking_group_id] || booking.ri_value,
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
    setIsChecked(false);
  };

  const openDiscountModal = (booking) => {
    setSelectedBooking(booking);
    setDiscountPercentage("");
    setDiscountReason("");
    setShowDiscountModal(true);
  };

  const openPopup = (bookingGroupId) => {
    setSelectedBookingId(bookingGroupId); // Store the ID for API call
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedRI(""); // Reset selection
  };

  const handleApproval = async () => {
    if (!selectedRI) {
      alert("Please select an RI value before approving.");
      return;
    }

    try {
      console.log(" Sending request:", selectedBookingId, selectedRI);

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBookingId,
          ri_value: selectedRI,
        }),
      });

      console.log("⏳ Waiting for response...");

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();
      console.log(" API Response:", updatedBooking);

      if (updatedBooking.success) {
        alert("Venue successfully approved!");
        myBookingsList();
        closePopup(); // Close modal
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error(" Error approving booking:", error);
    }
  };

 
  const [filters, setFilters] = useState({
    checkInDate: "",
    bookingDate: "",
    customerName: "",
    venueName: "",
    status: "",
  });

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

 
  const filteredBookings = paginatedBookingList.filter((rm) => {
    return (
      (!filters.checkInDate ||
        moment(rm.date).format("YYYY-MM-DD") ===
          moment(filters.checkInDate).format("YYYY-MM-DD")) && // Filter by check-in date
      (!filters.bookingDate ||
        moment(rm.booking_date).format("YYYY-MM-DD") ===
          moment(filters.bookingDate).format("YYYY-MM-DD")) && // Filter by booking date
      (!filters.customerName ||
        rm.customer_name
          .toLowerCase()
          .includes(filters.customerName.toLowerCase())) &&
      (!filters.venueName ||
        rm.room_names
          .toLowerCase()
          .includes(filters.venueName.toLowerCase())) &&
      (!filters.status || rm.status.toString() === filters.status)
    );
  });

  const cancelBooking = async (
    bookingGroupId,
    bookingDate,
    cancellationReason
  ) => {
    let userRole = localStorage.getItem("userRole");

    if (!userRole) {
      console.error("User type not found in localStorage");
      alert("User type not found. Please log in again.");
      return false;
    }

    userRole = parseInt(userRole, 10);

    console.log("Cancel Booking Request:", {
      bookingGroupId,
      bookingDate,
      cancellationReason,
      userRole,
    });

    try {
      const response = await fetch(
        `${host}/cancelBooking?bookingGroupId=${bookingGroupId}&reason=${encodeURIComponent(
          cancellationReason
        )}&userRole=${userRole}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      const data = await response.json();
      console.log("Server Response:", data);

      if (response.ok) {
        alert(data.message);
        return true; // Indicate success
      } else {
        alert("Cancellation failed: " + data.message);
        return false;
      }
    } catch (error) {
      console.error("Cancellation Error:", error);
      alert("Cancellation failed. Please try again later.");
      return false;
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setCancellationReason("");
    setSelectedBooking(null);
  };

  const handleModalSubmit = () => {
    if (!cancellationReason.trim()) {
      alert("Please provide a reason for cancellation.");
      return;
    }

    console.log("Cancellation reason:", cancellationReason); // Debugging
    cancelBooking(
      selectedBooking.booking_group_id,
      selectedBooking.date,
      cancellationReason
    );
    handleModalClose();
  };

  const handleApprove = async (bookingGroupId) => {
    if (!isChecked) {
      alert("Please confirm the details before approving.");
      return;
    }

    console.log("Approved Booking:", selectedBooking);

    try {
      console.log("Sending booking_group_id:", bookingGroupId); // Debugging

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({ booking_group_id: bookingGroupId }), // Send in the body
      });

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();

      if (updatedBooking.success) {
        alert("Venue successfully approved!"); // Show alert

        // 🔄 Re-fetch latest booking data after approval
        myBookingsList();

        closeModal();
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("Error approving booking:", error);
    }
  };

  const handlePageChange = (newPage) => {
    console.log("Page changed to:", newPage);
    setCurrentPage(newPage);

    const newPaginatedBookingList = bookingList.slice(
      (newPage - 1) * itemsPerPage,
      newPage * itemsPerPage
    );

    setPaginatedBookingList(newPaginatedBookingList);
  };

  const myBookingsListCallback = useCallback(() => {
    // myBookingsList();
  }, []);

 
  let userRole = localStorage.getItem("userRole");
  let billingRequest = JSON.parse("{}");
  let srNo = 0;
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    navigate("/", "_self");
  }

  

  const summaryView = (booking_group_id) => {
    fetch(
      host +
        "/getBookingSummary?bookingGroupId=" +
        booking_group_id +
        "&access_token=" +
        localStorage.getItem("access_token") +
        "&time=" +
        Math.round(new Date().getTime() / 1000),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      }
    ).then((response) => {
      response.json().then((rooms) => {
        if (rooms.length === 0) {
          console.error("No rooms found");
          return;
        }

        let bookingDetailsDataFinal = [];
        const orderId = rooms[0].order_id;
        console.log("Order ID:", orderId);

        billingRequest.locationId = rooms[0].location_id;
        billingRequest.name = rooms[0].customer_name;
        billingRequest.address = rooms[0].address;
        billingRequest.contactno = rooms[0].contact_no;
        billingRequest.email = rooms[0].email_id;
        billingRequest.pan = rooms[0].pan_number;
        billingRequest.aadhaar = rooms[0].aadhaar_number;
        billingRequest.razorpay_status = rooms[0].razorpay_status;
        billingRequest.orderId = rooms[0].booking_id;
        billingRequest.bookingId = rooms[0].order_id;
        billingRequest.is_approved = rooms[0].is_approved;

        rooms.map((row) => {
          let tmpBookingDetailsDataFinal = JSON.parse("{}");
          tmpBookingDetailsDataFinal["room_name"] = row.room_name;
          tmpBookingDetailsDataFinal["bookingDate"] = row.date;
          tmpBookingDetailsDataFinal["amount"] = row.sub_total;
          tmpBookingDetailsDataFinal["selectedPersons"] = row.extra_persons;
          tmpBookingDetailsDataFinal["finalGrandTotalVal"] = row.sub_total;

          bookingDetailsDataFinal.push(tmpBookingDetailsDataFinal);
          console.log("Row Sub Total:", row.sub_total);
        });

        billingRequest.roomData = bookingDetailsDataFinal;
        localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
        localStorage.setItem("bookingDetailsData", JSON.stringify("{}"));

        navigate("/BookingSummary", {
          state: {
            orderId: rooms[0].order_id,
            isApproved: rooms[0].is_approved,
          },
        });
      });
    });
  };

  console.log("tmpBookingDetailsDataFinal");
  const handleViewDocument = (fileUrl) => {
    if (!fileUrl) {
      alert("Document URL is not available.");
      return;
    }

    // Open the document in a new tab
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const myBookingsList = async () => {
    try {
      const response = await fetch(
        host +
          "/getMyBookingsList?access_token=" +
          localStorage.getItem("access_token") +
          "&time=" +
          Math.round(new Date().getTime() / 1000),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 403) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("access_token"); // Clear token
        navigate("/login", { replace: true }); // Redirect to login page
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch bookings");
      }

      const rooms = await response.json();
      console.log(rooms, "rooms");

      if (!Array.isArray(rooms)) {
        throw new Error("Invalid response format");
      }

      let bookingListArray = [];
      let bookingListTmp = {};

      if (rooms.length === 0) {
        setNoData("No booking details available");
      }

      rooms.forEach((row) => {
        // Group by booking_group_id and room_id
        const roomKey = `${row.booking_group_id}-${row.room_id}`;

        if (bookingListTmp[roomKey] !== undefined) {
          let tmp = bookingListTmp[roomKey];
          tmp.room_names = tmp.room_names + ", " + row.accommodation_type;

          // Ensure the sub_total is added only once for the room
          // Only add if the sub_total is not already set for this room in the group
          if (!tmp.sub_total) {
            tmp.sub_total = row.sub_total;
          }
          bookingListTmp[roomKey] = tmp;
        } else {
          row.room_names = row.room_names;
          // Set sub_total once for each room in the booking group
          row.sub_total = row.sub_total;
          bookingListTmp[roomKey] = row;
        }
      });

      // Convert the object to an array
      Object.keys(bookingListTmp).forEach((key) => {
        bookingListArray.push(bookingListTmp[key]);
      });

      const updatedBookingList = bookingListArray.map((booking) => {
        const checkOutDate = moment(booking.date);
        const currentDate = moment();
        const isDateCompleted = currentDate.isAfter(checkOutDate, "day");

        return {
          ...booking,
          cancelDisabled: booking.status === "Cancelled" || isDateCompleted,
        };
      });

      setBookingList(updatedBookingList);

      const newTotalPageCount = Math.ceil(
        updatedBookingList.length / itemsPerPage
      );
      setTotalPageCount(newTotalPageCount);

      // Update the paginated list based on the current page
      const newPaginatedBookingList = updatedBookingList.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

      setPaginatedBookingList(newPaginatedBookingList);

      console.log("Total Page Count:", newTotalPageCount);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      alert(
        "There was an error fetching your bookings. Please try again later."
      );
    }
  };

  const handleApplyDiscount = async () => {
    if (!discountPercentage || !discountReason) {
      alert("Please enter both discount percentage and reason.");
      return;
    }

    try {
      const response = await fetch(`${host}/applyDiscount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBooking.booking_group_id,
          discount_percentage: discountPercentage,
          reason: discountReason,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert("Discount applied successfully!");
        setShowDiscountModal(false);
        myBookingsList();
      } else {
        alert("Failed to apply discount.");
      }
    } catch (error) {
      console.error("Error applying discount:", error);
    }
  };

  const handleRiChange = async (selectedRi, bookingGroupId) => {
    if (!selectedRi) return;

    try {
      const response = await fetch(`${host}/updateRoomBookingRI`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: bookingGroupId,
          ri_value: selectedRi,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update RI value.");
      }

      alert("RI value updated successfully!"); // ✅ Alert before updating UI
      myBookingsList();
      // 🔄 Immediately update UI to replace dropdown with text
      setBookingList((prevBookings) =>
        prevBookings.map((booking) =>
          booking.booking_group_id === bookingGroupId
            ? { ...booking, ri_value: selectedRi }
            : booking
        )
      );
    } catch (error) {
      console.error("Error updating RI value:", error);
      alert("Error updating RI value.");
    }
  };

  const [totalPageCount, setTotalPageCount] = useState(1);

  const bookingSummary = () => {};

  const refreahData = () => {
    // myBookingsList();
  };

  useEffect(() => {
    myBookingsList();
    myBookingsListCallback();
  }, [currentPage]);
  const onChangeLocation = () => {
    
  };
  return (
    <div>
      <Header />
      {/* <Navbar /> */}
      <div className="container">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="row">
              <b>Booking Details</b>
            </div>

            <div className="filter-container">
              <div className="filter-item">
                <label>Event Date:</label>
                <input
                  type="date"
                  name="checkInDate"
                  value={filters.checkInDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="filter-item">
                <label>Booking Date:</label>
                <input
                  type="date"
                  name="bookingDate"
                  value={filters.bookingDate}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-item">
                <label>Customer Name:</label>
                <input
                  type="text"
                  name="customerName"
                  value={filters.customerName}
                  onChange={handleFilterChange}
                  placeholder="Enter Customer Name"
                />
              </div>

              <div className="filter-item">
                <label>Venue Name:</label>
                <input
                  type="text"
                  name="venueName"
                  value={filters.venueName}
                  onChange={handleFilterChange}
                  placeholder="Enter Venue Name"
                />
              </div>

              <div className="filter-item">
                <label>Status:</label>
                <select
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All Status</option>
                  <option value="1">Open</option>
                  <option value="2">Cancelled</option>
                  <option value="3">Pending</option>
                </select>
              </div>
            </div>

            <div className="row" style={{ overflowX: "auto" }}>
              <table className="table table-striped responsive-table">
                <thead>
                  <tr
                    className="data-row-head"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <th>S No</th>
                    <th>Venue Details</th>
                    <th>Venue Name</th>
                    <th>Event Date</th>

                    <th>Contact Name</th>
                    <th>Contact No</th>
                    {/* <th>Booking Status</th> */}
                    <th>Amount</th>
                    <th>Booking Date</th>

                    {(userRole == 4 || userRole == 2) && <th>Document</th>}
                    <th>Receipt</th>
                    {/* {userRole == 4 && <th>Assign RI</th>} */}

                    <th>status</th>
                    <th>electricity Attachment</th>
                    <th>damaged Attachment</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {/* <th>Cancellation Reason</th> */}
                  </tr>
                </thead>
                <tbody style={{ whiteSpace: "nowrap" }}>
                  {filteredBookings.map((rm, index) => (
                    <tr key={rm.booking_group_id} className="data-row-data">
                      <td style={{ textAlign: "center" }}>
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {rm.accommodation_type}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.room_names}</td>
                      <td style={{ textAlign: "center" }}>
                        {moment(rm.date).format("yyyy-MM-DD")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {rm.customer_name}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.contact_no}</td>

                      <td style={{ textAlign: "center" }}>{rm.sub_total}</td>
                      <td style={{ textAlign: "center" }}>
                        {moment(rm.booking_date).format("YYYY-MM-DD")}{" "}
                      </td>

                      {/* File URL (Only for userRole 1) */}
                      {userRole == 4 && (
                        <td>
                          {rm.file_url && (
                            <button
                              onClick={() => handleViewDocument(rm.file_url)}
                              className="view-document-button"
                            >
                              View
                            </button>
                          )}
                        </td>
                      )}

                      {/* Receipt (For normal users only, excluding blocked ones) */}
                      <td style={{ textAlign: "center" }}>
                        {userRole !== 1 && !rm.is_blocked && (
                          <i
                            className="fa-solid fa-download"
                            onClick={() => summaryView(rm.booking_group_id)}
                          ></i>
                        )}
                      </td>

                    

                      <td>open</td>
                     <td style={{ textAlign: "center" }}>
  {rm.reviews && rm.reviews.length > 0 && rm.reviews[0].electricityAttachment ? (
    <a href={rm.reviews[0].electricityAttachment} target="_blank" rel="noopener noreferrer">
      View
    </a>
  ) : (
    ""
  )}
</td>

<td style={{ textAlign: "center" }}>
  {rm.reviews && rm.reviews.length > 0 && rm.reviews[0].damagedAttachment ? (
    <a href={rm.reviews[0].damagedAttachment} target="_blank" rel="noopener noreferrer">
      View
    </a>
  ) : (
    ""
  )}
</td>

                      {/* Approve Button (Only for userRole 1) */}
                      {userRole == 4 && (
                        <td>
                          {rm.razorpay_status === "captured" &&
                          rm.status === 1 &&
                          rm.purpose ===
                            "Government Schools(school celebrations and cultural activities)" ? (
                            rm.is_approved ? (
                              <span
                                style={{ color: "green", fontWeight: "bold" }}
                              ></span>
                            ) : (
                              <button
                                // onClick={() => openPopup(rm.booking_group_id)}
                                onClick={() => openModal(rm)}
                                className="approveButton"
                                style={{
                                  padding: "6px",
                                  backgroundColor: "green",
                                  color: "white",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                Approve
                              </button>
                            )
                          ) : null}
                        </td>
                      )}

                      <td>
                        <button
                          onClick={() => handleCancelClick(rm)}
                          disabled={rm.cancelDisabled || rm.status === 2}
                          className={
                            "view-document-button " +
                            (rm.cancelDisabled || rm.status === 2
                              ? "disabledButton"
                              : "")
                          }
                          style={{
                            padding: "6px",
                            background: "#d20909e8",
                            border: "none",
                            borderRadius: "4px",
                            color: "#fff",
                          }}
                        >
                          {rm.status === 2 ? "cancelled" : "Cancel"}
                        </button>
                      </td>
                      {/* <td>
  <button
    onClick={() => handleCancelClick(rm)}
    disabled={rm.cancelDisabled || rm.status === 2}
    className={
      "view-document-button " +
      (rm.cancelDisabled || rm.status === 2 ? "disabledButton" : "")
    }
    style={{
      padding: "6px",
      background: "#d20909e8",
      border: "none",
      borderRadius: "4px",
      color: "#fff",
    }}
  >
    {rm.status === 2 ? "Cancelled" : "Cancel"}
  </button>
</td> */}


                      {(userRole == 4 || userRole == 3) && (
                        <td>
                          {rm.discount}{" "}
                          <button
                            className="edit-button"
                            onClick={() => openDiscountModal(rm)}
                            disabled={
                              rm.app_status !== "waiting for AO approval"
                            } // Button disabled if rm.app !== status
                            style={{
                              cursor:
                                rm.app_status === "waiting for AO approval"
                                  ? "pointer"
                                  : "not-allowed",
                              background:
                                rm.app_status === "waiting for AO approval"
                                  ? "blue"
                                  : "gray",
                              color: "white",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              marginLeft: "5px",
                              opacity:
                                rm.app_status === "waiting for AO approval"
                                  ? 1
                                  : 0.5, // Reduce opacity when disabled
                            }}
                          >
                            Refund
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {showModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <h3>Reason for Cancellation</h3>
                  <textarea
                    value={cancellationReason}
                    onChange={(e) => setCancellationReason(e.target.value)}
                    placeholder="Enter reason for cancellation"
                    rows="4"
                    style={{ width: "100%" }}
                  />
                  <div style={{ marginTop: "10px" }}>
                    <button
                      onClick={handleModalSubmit}
                      style={{ marginRight: "10px" }}
                    >
                      Submit
                    </button>
                    <button onClick={handleModalClose}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {showPopup && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <h3>Allot To RI</h3>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI1"
                      checked={selectedRI === "RI1"}
                      onChange={() => setSelectedRI("RI1")}
                    />
                    <label className="form-check-label">RI1</label>
                  </div>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI2"
                      checked={selectedRI === "RI2"}
                      onChange={() => setSelectedRI("RI2")}
                    />
                    <label className="form-check-label">RI2</label>
                  </div>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI3"
                      checked={selectedRI === "RI3"}
                      onChange={() => setSelectedRI("RI3")}
                    />
                    <label className="form-check-label">RI3</label>
                  </div>
                  <div className="popup-buttons">
                    {/* <button onClick={handleApproval} className="approveButton">
                      Approve
                    </button> */}

                    <button
                      type="button"
                      onClick={handleApproval}
                      className="approveButton"
                    >
                      Approve
                    </button>

                    <button onClick={closePopup} className="cancelButton">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showDiscountModal && selectedBooking && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <h3>Apply Discount</h3>
                  <p>
                    <strong>Name:</strong> {selectedBooking.customer_name}
                  </p>
                  <p>
                    <strong>Mobile No:</strong> {selectedBooking.contact_no}
                  </p>
                  <p>
                    <strong>Amount:</strong> Rs.{selectedBooking.sub_total}
                  </p>

                  <label>Discount Percentage (%):</label>
                  <input
                    type="number"
                    value={discountPercentage}
                    onChange={(e) => setDiscountPercentage(e.target.value)}
                    min="0"
                    max="100"
                  />

                  <label>Reason:</label>
                  <textarea
                    value={discountReason}
                    onChange={(e) => setDiscountReason(e.target.value)}
                  />

                  <div className="popup-buttons">
                    <button
                      onClick={handleApplyDiscount}
                      className="approveButton"
                    >
                      Apply Discount
                    </button>
                    <button
                      onClick={() => setShowDiscountModal(false)}
                      className="cancelButton"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* refund modal original */}

            {showDiscountModal && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Refund </h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => setShowRefundModal(false)}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* Venue & Event Details */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("YYYY-MM-DD")}
                        </span>
                      </div>
                    </div>

                    {/* Customer Info */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Charges Table */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="row">
                      {/* Remarks Section */}

                      <div className="col-6">
                        <label>Remarks (RI)</label>
                        {selectedBooking.reviews &&
                        selectedBooking.reviews.length > 0 ? (
                          <textarea
                            value={selectedBooking.reviews
                              .map(
                                (review, index) =>
                                  `Remark ${index + 1}: ${review.remark || "No remark available"}`
                              )
                              .join("\n")}
                            readOnly
                            className="popup-textarea"
                            rows={3}
                            style={{
                              backgroundColor: "#f0f0f0",
                              fontWeight: "bold",
                              width: "100%",
                            }}
                          />
                        ) : (
                          <textarea
                            value="No remarks available"
                            readOnly
                            className="popup-textarea"
                            rows={3}
                            style={{
                              backgroundColor: "#f0f0f0",
                              fontWeight: "bold",
                              width: "100%",
                            }}
                          />
                        )}
                      </div>

                      {/* Attachments Section */}
                      <div className="col-3">
                        <label>Damaged Attachment</label>
                        {selectedBooking.reviews &&
                        selectedBooking.reviews.some(
                          (review) => review.damagedAttachment
                        ) ? (
                          selectedBooking.reviews.map((review, index) =>
                            review.damagedAttachment ? (
                              <a
                                key={index}
                                href={review.damagedAttachment}
                                download
                                className="view-document-button"
                              >
                                View
                              </a>
                            ) : null
                          )
                        ) : (
                          <p>No attachment</p>
                        )}
                      </div>

                      <div className="col-3">
                        <label>Electricity Attachment</label>
                        {selectedBooking.reviews &&
                        selectedBooking.reviews.some(
                          (review) => review.electricityAttachment
                        ) ? (
                          selectedBooking.reviews.map((review, index) =>
                            review.electricityAttachment ? (
                              <a
                                key={index}
                                href={review.electricityAttachment}
                                download
                                className="view-document-button"
                              >
                                View
                              </a>
                            ) : null
                          )
                        ) : (
                          <p>No attachment</p>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      {/* Left Section - Security Refund */}
                      <div className="col-4">
                        <label>
                          Refund Security Amount
                          <strong style={{ fontSize: "15px" }}></strong>
                        </label>
                        <input
                          type="number"
                          value={calculatedRefund}
                          onChange={(e) =>
                            setCalculatedRefund(Number(e.target.value) || 0)
                          }
                          min="0"
                          max={selectedBooking.total_security_deposit}
                          className="popup-input"
                          placeholder="Enter refund amount"
                          style={{ width: "100%" }}
                        />
                      </div>

                      {/* Middle Section - Discount Amount */}
                      <div className="col-4">
                        <label>Discount Amount</label>
                        <input
                          type="text"
                          value={`₹${selectedBooking.discount_amount || 0}`}
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                          }}
                        />
                      </div>

                      {/* Right Section - Total Refund Amount */}
                      <div className="col-4">
                        <label>Total Refund Amount</label>
                        <input
                          type="text"
                          value={`₹${(Number(calculatedRefund) || 0) + Number(selectedBooking.discount_amount || 0)}`}
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                            width: "100%",
                          }}
                        />
                      </div>
                    </div>

                    {/* Total Refund Calculation */}
                    <div className="row">
                      <div className="col-8">
                        <label>
                          <strong>Reason</strong>
                        </label>
                        <textarea
                          value={refundReason}
                          onChange={(e) => setRefundReason(e.target.value)}
                          className="popup-textarea"
                          placeholder="Enter reason"
                          rows={4}
                          style={{ width: "100%", height: "66px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={handleProcessRefund}
                      className="approve-btn"
                    >
                      Process Refund
                    </button>
                    <button
                      onClick={() => setShowDiscountModal(false)}
                      className="cancelButton"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showCancelModal && selectedItem && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Cancel Booking</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => setShowCancelModal(false)}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* Booking Details */}{" "}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedItem.date).format("YYYY-MM-DD")}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.email || "N/A"}
                        </span>
                      </div>
                    </div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedItem.total_rent}</td>
                          <td>₹{selectedItem.total_gst}</td>
                          <td>₹{selectedItem.total_security_deposit}</td>
                          <td>₹{selectedItem.total_cleaning_charges}</td>
                          <td>₹{selectedItem.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>
                    {/* Cancellation Reason */}
                    <div className="row">
                      <div className="col-12">
                        <label>
                          <strong>Cancellation Reason</strong>
                        </label>
                        <textarea
                          value={cancelReason}
                          onChange={(e) => setCancelReason(e.target.value)}
                          className="popup-textarea"
                          placeholder="Enter reason"
                          rows={4}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button onClick={() => cancelBooking(selectedItem.booking_group_id, selectedItem.date, cancelReason)} className="approve-btn">
                      Confirm Cancellation
                    </button>
                    <button
                      onClick={() => setShowCancelModal(false)}
                      className="cancel-btn"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Approve Booking</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={closeModal}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    <br />
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("YYYY-MM-DD")}
                        </span>
                      </div>
                    </div>

                    {/* Second Line: Customer Name, Phone, Email */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Third Line: Tabular Format for Rent, GST, etc. */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Purpose & Proof Attachment */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Concession Type &nbsp;:</strong>
                        </span>
                        <span>&nbsp; {selectedBooking.purpose || "N/A"}</span>
                      </div>
                    </div>

                    {selectedBooking.file_url && (
                      <div className="row">
                        <div className="col-12">
                          <span>
                            <strong>Attachment of Proof &nbsp;:</strong>
                          </span>
                          <a href={selectedBooking.file_url} target="_blank">
                            &nbsp; view
                          </a>
                        </div>
                      </div>
                    )}

                    {/* Assigned to RI */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Assigned to &nbsp;:</strong>
                        </span>
                        <span>
                          &nbsp;
                          {selectedBooking.ri_value ||
                            selectedRI[selectedBooking.booking_group_id] ||
                            "Not Assigned"}
                        </span>
                      </div>
                    </div>

                    {/* Checkbox Confirmation */}
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="confirmCheck"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="confirmCheck"
                      >
                        I confirm that the details are correct.
                      </label>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={() =>
                        handleApprove(selectedBooking.booking_group_id)
                      }
                      disabled={!isChecked}
                      className="approve-btn"
                    >
                      Approve
                    </button>
                    <button onClick={closeModal} className="cancel-btn">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="col-lg-2"></div>
            <div className="pagination">
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span
                style={{ paddingTop: "15px" }}
              >{`Page ${currentPage} of ${totalPageCount}`}</span>
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPageCount}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBookings;
